<template>
    <div class="footer">
        <!--s: 欢迎关注 -->
        <div class="footer-contact">
            <div class="main">
                <div class="footer-attention">
                    <p class="tit">欢迎关注</p>
                    <a href="http://blog.ximalaya.com/" target="_blank">
                        <i class="icon icon-24 icon-ximalaya-logo mr10 va-mid"></i><span>官方博客</span>
                    </a>
                    <a href="http://weibo.com/ximala/" target="_blank">
                        <i class="icon icon-24 icon-weibo-logo mr10 va-mid"></i>新浪微博
                    </a>
                    <a class="weixin" @click="showWechatCode" href="javascript:;">
                        <i class="icon icon-24 icon-wechat-logo mr10 va-mid"></i>微信公众号
                    </a>
                    <a class="js-qq" @click="showQQCode" href="javascript:;">
                        <i class="icon icon-24 icon-qq-logo mr10 va-mid"></i>QQ公众号
                    </a>
                    <a href="http://tieba.baidu.com/f?kw=%E5%96%9C%E9%A9%AC%E6%8B%89%E9%9B%85fm" target="_blank">
                        <i class="icon icon-24 icon-baidu-logo mr10 va-mid"></i>贴吧
                    </a>
                    <a href="http://buluo.qq.com/p/barindex.html?bid=272710" target="_blank">
                        <i class="icon icon-24 icon-tribe-logo mr10 va-mid"></i>兴趣部落
                    </a>
                </div>
            </div>
        </div>
        <!--e: 欢迎关注 -->

        <!--s: 欢迎关注 -->
        <div class="footer-copyright">
            <p class="copyright-cont">
                <a href="http://www.ximalaya.com/help/aboutus/" target="_blank">关于我们</a> |
                <a href="http://www.ximalaya.com/help/contact_us/" target="_blank">联系我们</a> |
                <a href="http://www.ximalaya.com/help/official_news/" target="_blank">公司新闻</a> |
                <a href="http://www.ximalaya.com/help/join_us/" target="_blank">招贤纳士</a> |
                <a href="http://www.ximalaya.com/passport/register_rule" target="_blank">使用协议</a> |
                <a href="javascript:;" @click="protocolDialogVisible = true" class="copy_right">版权声明</a> |
                <a href="http://open.ximalaya.com" target="_blank">开放平台</a>
            </p>
            <p class="copyright-cont">
                Copyright © 2012-2018 www.ximalaya.com lnc.ALL Rights Reserved
            </p>
            <p class="copyright-cont">
                上海证大喜马拉雅网络科技有限公司 版权所有
            </p>
            <p class="copyright-cont">
                沪网文【2016】6034-453号沪ICP备13027243号-3沪公网安备 31011502005603号
            </p>
        </div>
        <!--e: 欢迎关注 -->
        <!-- wechat -->
        <el-dialog v-model="wechatDialogVisible" top="30%" :close-on-click-modal="true" :show-close="false" size="tiny">
            <span slot><img :src="`${IMG_HOST}code_xmly_weixin.jpg`"></span>
            <span slot="title"></span>
            <span slot="footer"></span>
        </el-dialog>
        <!-- qq -->
        <el-dialog v-model="QQDialogVisible" top="30%" :close-on-click-modal="true" :show-close="false" size="tiny">
            <span slot><img :src="`${IMG_HOST}code_xmly_qq.jpg`"></span>
            <span slot="title"></span>
            <span slot="footer"></span>
        </el-dialog>
        <el-dialog title="版权声明" custom-class="protocol-pop" v-model="protocolDialogVisible" top="15%" :close-on-click-modal="true" :show-close="false" size="small">
            <div slot>
                <p class="indented">上海证大喜马拉雅网络科技有限公司（以下简称：“喜马拉雅网”）根据用户指令提供作品上传、下载以及传播等，向来十分重视网络版权及其他知识产权以及用户权益的保护。</p>
                <p class="indented">如果您认为喜马拉雅网用户通过喜马拉雅网提供的信息存储空间所上载、传播的视听内容侵犯了您的相关权益的，请您向喜马拉雅网发出权利通知，喜马拉雅网将根据相关法律规定采取措施删除相关内容，您可以向喜马拉雅网所设立的专门接受版权投诉和侵权通知的邮箱发送通知书。</p>
                <p style="color:#fc5832;font-weight: 400;">肖像、名誉等申诉</p>
                <p class="indented">其中侵犯公民个人名誉权、肖像权的投诉资料请发至： tousu@ximalaya.com</p>
                <p style="color:#fc5832;font-weight: 400;">版权申诉</p>
                <p class="indented">侵犯个人或单位的著作权、商标权等知识产权的情况请将投诉资料发至：banquan@ximalaya.com</p>
                <p style="color:#fc5832;font-weight: 400;">申诉需知</p>
                <p>投诉方应当提供包含下列文件：</p>
                <p class="indented">1、完整填写的申请书</p>
                <p class="indented">2、权利人的姓名（名称）、联系方式、地址、身份证扫描件（自然人）、企业法人营业执照（单位）、法定代表人身份证明（单位）；</p>
                <p class="indented">3、要求删除或者断开链接的侵权作品的准确名称和网络地址，以便喜马拉雅网能够发现并初步审核涉嫌侵权作品；</p>
                <p class="indented">4、认为构成侵权的初步证明材料，包括但不限于对作品享有版权或依法享有信息网络传播权的权属证明，以及对涉嫌侵权作品侵权事实的举证。</p>
                <p class="indented">5、通知书需由权利人或其合法授权人亲笔签名，若为单位则需加盖单位公章。</p>
                <p class="indented">6、权利人应对通知书的真实性负责。若通知书的内容不真实，权利人将承担由此造成的全部法律责任。</p>
                <p class="indented">一旦收到符合上述要求之通知，我们将在合理时间内删除涉嫌侵权的作品。如不符合上述条件，我们会请阁下提供相应信息，且暂不采取包括删除等相应措施。</p>
                <p class="indented">在喜马拉雅网上载作品的用户视为同意喜马拉雅网就前款情况所采用的相应措施。喜马拉雅网不因此而承担任何违约责任或其他任何法律责任。喜马拉雅网在收到上述通知后会发送电子邮件通知上载该等作品的用户。对于多次上载涉嫌侵权作品的用户，我们将取消其用户资格。</p>
                <p>附件</p>
                <p class="indented">1、<a href="http://s1.xmcdn.com/doc/copyright_personal.doc?20150529090608">申请书（个人适用）</a></p>
                <p class="indented">2、<a href="http://s1.xmcdn.com/doc/copyright_unit.doc?20150529090608">申请书（法人单位适用）</a></p>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        components: {
        
        },
        data() {
            return {
              wechatDialogVisible: false,
              QQDialogVisible: false,
              protocolDialogVisible: false
            }
        },
        computed: {
          IMG_HOST(){
            return this.$store.state.IMG_HOST;
          }
        },
        methods: {
          showWechatCode() {
            this.wechatDialogVisible = true;
          },
          showQQCode() {
            this.QQDialogVisible = true;
          }
        }
    }

</script>
<style lang="sass" scope>@import "../../sass/components/footer.scss";</style>


// WEBPACK FOOTER //
// Footer.vue?bffa10e0